import { Toast } from "primereact/toast";
import React, {useEffect, useRef} from "react";
import {useStateRef} from "../../../hooks/useStateRef";

const GLOBAL_ALERT_EVENT_NAME = "EasasGlobalAlertEvent"


export default function EasasGlobalAlerts() {
    const toastRef = useRef<Toast>(null);
    const [_, setAlert, alertRef] = useStateRef<EasasGlobalAlertEventDetail | null>(null);



    useEffect(() => {
        let duplicateTimeout: NodeJS.Timeout | null = null;
        const listener = (e: EasasGlobalAlertEvent) => {
            if(alertsEqual(alertRef.current, e.detail)) {
                duplicateTimeout = setTimeout(() => {
                    setAlert(null);
                }, 2000);
            } else {
                toastRef.current?.show({
                    severity: e.detail?.type ?? "info",
                    summary: e.detail?.message,
                    detail: e.detail?.detail,
                    life: 5000,
                })
                setAlert(e.detail);
            }
        }


        window.addEventListener(GLOBAL_ALERT_EVENT_NAME, listener as EventListener)
        return () => {
            if(duplicateTimeout != null) {
                clearTimeout(duplicateTimeout);
            }
            window.removeEventListener(GLOBAL_ALERT_EVENT_NAME, listener as EventListener)
        }
    }, []);

    return <Toast ref={toastRef}/>
}



export function easasAlert(message: string, detail?: string, type: "info" | "warn" | "error" | "success" = "info") {
    dispatchEvent(new EasasGlobalAlertEvent({message, detail, type}))
}

class EasasGlobalAlertEvent extends CustomEvent<EasasGlobalAlertEventDetail> {
    constructor(msg: EasasGlobalAlertEventDetail) {
        super(GLOBAL_ALERT_EVENT_NAME, { detail: msg });
    }
}

interface EasasGlobalAlertEventDetail {
    message: string,
    detail?: string,
    type: "info" | "warn" | "error" | "success",
}

function alertsEqual(a: EasasGlobalAlertEventDetail | null, b: EasasGlobalAlertEventDetail | null) {
    if (a == null && b == null) {
        return true;
    }

    if (a == null || b == null) {
        return false;
    }

    return a.message == b.message && a.detail == b.detail && a.type == b.type;
}

